import { render } from "./editLabs.vue?vue&type=template&id=18435c49&scoped=true"
import script from "./editLabs.js?vue&type=script&lang=js"
export * from "./editLabs.js?vue&type=script&lang=js"

import "./editLabs.vue?vue&type=style&index=0&id=18435c49&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18435c49"]])

export default __exports__